import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const DashboardProfileComponent = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 12px 16px 16px;
  box-sizing: border-box;
  background-color: #fafdff;
  border-radius: 20px;

  @media (max-width: ${screenSizes.tablet}) {
    border-radius: 20px 20px 0px 0px;
    width: 100vw;
  }

  .profile-text {
    color: #191919;
  }

  .profile-header {
    flex-shrink: 0;
  }

  .profile-title {
    font-size: 35px;
    margin: 8px 0 0;
  }

  .greeting {
    font-size: 25px;
    margin: 0px;
  }

  .profile-details-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding-right: 4px;
    margin-right: -4px;
  }

  .profile-card {
    margin-top: 20px;
    max-width: 720px;
    background: #fff;
    border: 1px solid #e8edf2;
    border-radius: 16px;
    padding: 24px;
  }

  .profile-identity {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-bottom: 20px;
    margin-bottom: 8px;
    border-bottom: 1px solid #eef2f6;

    @media (max-width: ${screenSizes.tablet}) {
      flex-direction: column;
      text-align: center;
    }
  }

  .profile-avatar {
    width: 112px;
    height: 112px;
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;
    background: #f1f4f7;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .profile-display-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  .profile-display-placeholder {
    padding: 12px;
    text-align: center;
    color: #8a96a3;
    font-size: 13px;
  }

  .profile-identity-copy {
    min-width: 0;
  }

  .profile-name {
    margin: 0;
    font-size: 1.45rem;
    font-weight: 700;
    line-height: 1.25;
    color: #1a1a1a;
  }

  .profile-id {
    margin: 4px 0 0;
    font-size: 0.95rem;
    color: #6b7785;
  }

  .edit-profile-open.ui.button {
    margin: 14px 0 0 !important;

    @media (max-width: ${screenSizes.tablet}) {
      width: 100%;
    }
  }

  .profile-facts {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0;
    margin: 0;

    @media (max-width: ${screenSizes.tablet}) {
      grid-template-columns: 1fr;
    }
  }

  .profile-fact {
    padding: 14px 12px 14px 0;
    border-bottom: 1px solid #f0f3f6;

    dt {
      margin: 0 0 4px;
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      color: #8a96a3;
    }

    dd {
      margin: 0;
      font-size: 1.05rem;
      font-weight: 600;
      color: #1a1a1a;
      word-break: break-word;
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    width: 100vw;
  }
`;
